<div class="mp-dialog">
    <div class="mp-dialog-header px-3 px-md-6 py-2">
        <div class="d-flex gap-3">
            @if (icon()) {
                <ui-icon-bs [type]="icon().variant" [iconClass]="'text-' + icon()?.style || 'black'" />
            }

            <div>
                @if (title()) {
                    <h3 class="mb-0">{{ title() | translate }}</h3>
                }
                @if (description()) {
                    <div class="mp-dialog-description">{{ description() | translate }}</div>
                }
            </div>
            <ui-icon-bs class="ms-auto"
                        mat-dialog-close
                        [type]="bsIconTypes.XLg"
                        [pseudo]="'gray'"
                        [ariaLabel]="'global.actions.close' | translate" />
        </div>
    </div>

    <mat-dialog-content [ngClass]="dialogContentPaddingClass()">
        <ng-container *ngComponentOutlet="component; injector: injectorData"></ng-container>
    </mat-dialog-content>
</div>
